export default __webpack_public_path__ + "static/media/rose-grey.8c9288fd.svg";